export const Home = () => {
  return (
    <div className="home">
      <div className="home-text">
        <p>SoundScape is made possible thanks to the Spotify Web API and Spotify Web Playback SDK.</p>
        <br />
        <p>Some features such as listening to music within the SoundScape browser may be limited and/or unavailable without a Spotify Premium account.</p>
        <p>To get the full SoundScape experience, please log in with an account subscribed to Spotify Premium.</p>
        <br />
        <p>To get started with the app, click on the home button to navigate to a different part of the app.</p>
      </div>
    </div>
  )
}